/*
 * Collection pages: show Eau de Parfum products first, then Eau de Toilette, then roll-ons, then the others.
 * Each product card carries data-product-group (1 / 2 / 3 / 4, see snippets/product-thumbnail.liquid).
 * Collections are paginated server-side, so every page is loaded here and the whole list is
 * re-ordered (stable: the existing order is kept inside each group).
 */
(function () {
  'use strict';

  function isThumbnail(el) {
    return el.nodeType === 1 && el.classList.contains('product__thumbnail');
  }

  function groupOf(el) {
    return parseInt(el.getAttribute('data-product-group'), 10) || 4;
  }

  function sortInto(matrix, items) {
    var decorated = items.map(function (el, index) {
      return { el: el, index: index, group: groupOf(el) };
    });
    decorated.sort(function (a, b) {
      return a.group - b.group || a.index - b.index;
    });
    var fragment = document.createDocumentFragment();
    decorated.forEach(function (entry) { fragment.appendChild(entry.el); });
    matrix.appendChild(fragment);
  }

  function loadPage(pageNumber) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', pageNumber);
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var otherMatrix = doc.querySelector('.collection-matrix');
        if (!otherMatrix) return [];
        return Array.prototype.filter.call(otherMatrix.children, isThumbnail).map(function (node) {
          return document.importNode(node, true);
        });
      });
  }

  function run() {
    var matrix = document.querySelector('.collection-matrix');
    if (!matrix || matrix.getAttribute('data-format-sorted')) return;
    matrix.setAttribute('data-format-sorted', 'loading');

    var paginate = document.querySelector('[data-collection-main] .paginate');
    var pages = paginate ? parseInt(paginate.getAttribute('data-paginate-pages'), 10) || 1 : 1;
    var current = paginate ? parseInt(paginate.getAttribute('data-current-page'), 10) || 1 : 1;
    var own = Array.prototype.filter.call(matrix.children, isThumbnail);

    if (pages <= 1) {
      sortInto(matrix, own);
      matrix.setAttribute('data-format-sorted', 'done');
      return;
    }

    matrix.classList.add('is-format-sorting');

    var requests = [];
    for (var n = 1; n <= pages; n++) {
      if (n === current) {
        requests.push(Promise.resolve(own));
      } else {
        requests.push(loadPage(n));
      }
    }

    Promise.all(requests)
      .then(function (results) {
        var all = [];
        results.forEach(function (items) { all = all.concat(items); });
        sortInto(matrix, all);
        var pagination = document.querySelector('[data-collection-main] .container--pagination');
        if (pagination) pagination.style.display = 'none';
        matrix.setAttribute('data-format-sorted', 'done');
      })
      .catch(function () {
        sortInto(matrix, own);
        matrix.setAttribute('data-format-sorted', 'failed');
      })
      .then(function () {
        matrix.classList.remove('is-format-sorting');
      });
  }

  function init() {
    run();
    var main = document.querySelector('[data-collection-main]');
    if (main && 'MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(run, 50);
      }).observe(main, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
